import moment from 'moment';
import React, { useEffect, useState, useRef } from 'react';
import Lottie from 'react-lottie';
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import io from "socket.io-client";
import { Button, Card, FormGroup, Icon, MenuItem, Switch, Menu, Collapse, Position, Popover } from '@blueprintjs/core';
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import { Select, MultiSelect } from "@blueprintjs/select";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import PublicLinkManager from './PublicLinkManager';

import { IconeHome } from '../../Assets';
import { SignIn as ContextSignIn, SignIn, WidthCheck as ContextWidthCheck } from '../../Context';
import { Localization } from '../../Data/Listas';
import { CentroDeCusto, Identificador } from '../../Services/Controllers';
import api from '../../Services/node';
import { Moeda } from '../../Themes/TextFormat';
import { Objeto } from '../../Services/Models';
import { NotificacaoInterna } from '../../Services/Notification';
import * as LottieFiles from '../../Data/Lottie';
import apiAdonis from '../../Services/adonis';

import './App.css';
import Map from './leaflet';
import { image } from './image';
import * as Component from './style';
import './style.css';
import viewModel from './viewModel';

const View: React.FC = () => {

    /* #region  Variáveis  */
    const [getExibirMapa, setExibirMapa] = useStateWithCallbackLazy<boolean>(false);
    const [getWidth, setWidth] = useState<number>();

    /* #region  Variáveis da tabela de disponibilidade */
    const [getItemPickerCentroDeCusto, setItemPickerCentroDeCusto] = useState<Objeto.CentroDeCusto>();
    const [getListaPickerCentroDeCustoDisponibilidade, setListaPickerCentroDeCustoDisponibilidade] = useState<Array<Objeto.CentroDeCusto>>([]);
    const PickerCentroDeCusto = Select.ofType<Objeto.CentroDeCusto>();
    const [getCarregandoListaDeUnidades, setCarregandoListaDeUnidades] = useStateWithCallbackLazy<boolean | undefined>(undefined);
    /* #endregion */

    /* #region  Variáveis do mapa */
    const [getListaPickerCentroDeCustoMapa, setListaPickerCentroDeCustoMapa] = useState<Array<Objeto.CentroDeCusto>>([]);
    const [getEmpresaObra, setEmpresaObra] = useState<any>([]);
    const [getRefreshData, setRefreshData] = useState<any>();
    const [getMapRefreshed, setMapRefreshed] = useState<any>(true);
    const [getListaDeMarcacoes, setListaDeMarcacoes] = useState<any>();
    const [getTiposInadimplencia, setTiposInadimplencia] = useState<any>();
    const [getListaPontosCentrais, setListaPontosCentrais] = useState<any>();
    const [getListaAreas, setListaAreas] = useState<any>();
    const [getVisaoMapa, setVisaoMapa] = useState<number>(0);
    const [getCarregandoListaDeMarcacoes, setCarregandoListaDeMarcacoes] = useStateWithCallbackLazy<boolean | undefined>(undefined);
    const [getCollapse, setCollapse] = useState(false);
    const [getFullscreen, setFullscreen] = useState(false);
    const [cd_emp, setCdEmp] = useState<number>();
    const handle = useFullScreenHandle();
    const [showPublicLinkManager, setShowPublicLinkManager] = useState<boolean>(false);
    /* #endregion */

    async function getEmpTipo() {
        // Verificar se o usuário está autenticado
        const user = localStorage.getItem("user");
        
        if (user) {
            // Usuário autenticado - buscar permissões
            try {
                await apiAdonis.get("/empPerms", {
                    params: { userId: JSON.parse(user).id }
                }).then(res => {
                    const emp_permissions: { cd_emp: number }[] | [] = res.data;
                    if (emp_permissions.length > 1) {
                        const options: any = [];
                        let prompt_text;

                        let i = ""
                        emp_permissions.forEach(emp => {
                            const emp_name = emp.cd_emp === 1 ? "Rio" :
                                emp.cd_emp === 2 ? "Gav" :
                                    emp.cd_emp === 3 ? "Omie" :
                                        emp.cd_emp === 4 ? "BP8" :
                                            emp.cd_emp === 20 ? "Espaco" :
                                                emp.cd_emp === 25 ? "CasaETerra" : null;
                            i += `${emp.cd_emp} - ${emp_name}\n`
                            options.push({ cd_emp: emp.cd_emp, emp_name: emp_name })
                        })
                        prompt_text = i;

                        let choose = prompt(prompt_text);
                        while (!options.find((option: any) => option.cd_emp === Number(choose))) {
                            choose = prompt(prompt_text);
                        }
                        setCdEmp(options.find((option: any) => option.cd_emp === Number(choose)).cd_emp);
                    }
                    else if (emp_permissions.length === 1) {
                        setCdEmp(emp_permissions[0].cd_emp);
                    } else {
                        // Sem permissões, definir valor padrão
                        setCdEmp(1); // Definindo Rio como padrão
                    }
                });
            } catch (error) {
                console.error("Erro ao buscar permissões:", error);
                setCdEmp(1); // Definindo Rio como padrão em caso de erro
            }
        } else {
            // Usuário não autenticado - definir valor padrão
            setCdEmp(1); // Definindo Rio como padrão
        }

        return
    }

    window.onresize = function () {
        ContextWidthCheck.setContext({ width: document.body.clientWidth })
        setWidth(document.body.clientWidth)
    }
    function WidthCheck() {
        if (window.location.pathname == "/Disponibilidade") {
            if (window.matchMedia("(min-width: 1024px && max-width: 2560px)").matches == true) {
                return { display: "flex", alignItems: "flex-end", flexWrap: "wrap", backgroundColor: "0", width: "97%", margin: "20px auto", justifyContent: "space-between" } as React.CSSProperties
            } else if (window.matchMedia("(max-width: 1024px)").matches == true) {
                return { display: "flex", alignItems: "flex-end", flexWrap: "wrap", backgroundColor: "0", width: "97%", margin: "20px auto", justifyContent: "center" } as React.CSSProperties
            }
        }
    }
    async function RefreshData(Item: Objeto.CentroDeCusto) {
        if (getRefreshData) {
            RemoveRefreshData();
        }
        await api.get(`/allMaps?empresaMae=Cosentino&obra=${Item?.sigla}`).then(async results => {
            await setMapRefreshed(false);
            await setListaDeMarcacoes(results.data);
            await setMapRefreshed(true);
            await setCarregandoListaDeMarcacoes(false, () => { });
            setRefreshData(setInterval(async function () {
                await api.get(`/allMaps?empresaMae=Cosentino&obra=${Item?.sigla}`).then(async results => {
                    await setMapRefreshed(false);
                    await setListaDeMarcacoes(results.data);
                    await setMapRefreshed(true);
                })
            }, 20000));
        });
    }
    function RemoveRefreshData() {
        clearInterval(getRefreshData);
        setRefreshData(undefined);
    }

    useEffect(() => {
        WidthCheck();
    }, [document.body.clientWidth]);

    useEffect(() => {
        async function componentDidMount() {
            await getEmpTipo();
        }
        componentDidMount();
    }, [])

    useEffect(() => {
        async function componentDidMount() {
            switch (cd_emp) {
                case 25:
                    await api.get(`/Mapas/Empreendimentos?empresaMae=CasaETerra`).then(async results => await setListaPickerCentroDeCustoMapa(results.data.empreendimentos));
                    break;
                case 9:
                    await api.get(`/Mapas/Empreendimentos?empresaMae=Cosentino`).then(async results => await setListaPickerCentroDeCustoMapa(results.data.empreendimentos));
                    break;
                case 1:
                    await api.get(`/Mapas/Empreendimentos?empresaMae=Rio`).then(async results => await setListaPickerCentroDeCustoMapa(results.data.empreendimentos));
                    break;
                default:

            }
        }
        componentDidMount();
    }, [cd_emp]);

    return (
        <Component.Container>
            <FullScreen handle={handle}>
                <Collapse isOpen={getCollapse}>
                    <div className="endereco" style={WidthCheck()}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <img src={IconeHome} alt="" style={{ width: "20px", height: "20px" }} />
                            <div className="bar">/</div>
                            <div className="place">Mapas</div>
                            <div className="bar">/</div>
                            <PickerCentroDeCusto popoverProps={{ popoverClassName: "bp3-multi-select-popover" }} items={getListaPickerCentroDeCustoMapa} onItemSelect={() => { }} noResults={<MenuItem style={{ position: "relative", zIndex: 20000 }} disabled={getCarregandoListaDeMarcacoes} text="Sem resultados disponíveis" />}
                                itemRenderer={(Item: Objeto.CentroDeCusto) => <MenuItem style={{ position: "relative", zIndex: 90000 }}
                                    onClick={async () => {
                                        await setItemPickerCentroDeCusto(Item)
                                        await setCarregandoListaDeMarcacoes(true, async () => { })
                                        RemoveRefreshData();
                                        await setListaDeMarcacoes(undefined);
                                        await setTiposInadimplencia(undefined);
                                        await setListaAreas(undefined);

                                        await api.get(`/allMaps?empresaMae=${Item.empresa}&obra=${Item.sigla}`/*'/Maps?pastaEmp=ChapadaoDoSul&empresaMae=CasaETerra&empresa=12&obra=0814V'*/).then(async results => {
                                            await setListaDeMarcacoes(/*Response.data*/results.data);
                                            await setTiposInadimplencia(results.data.tiposInadimplencia);
                                            await setListaAreas(results.data.others);
                                            await setCarregandoListaDeMarcacoes(false, () => { });
                                        })
                                        if (getExibirMapa === false) {
                                            await setExibirMapa(!getExibirMapa, async () => { });
                                        }
                                    }} text={Item.descricao} />} itemPredicate={(Texto: string, Item: Objeto.CentroDeCusto) => { return (Item.descricao ?? "").toUpperCase().includes(Texto.toUpperCase()) || Texto == "" }}>
                                <Button intent="none" icon={"fullscreen"} onClick={handle.enter} text={"Tela Inteira"} />
                                <Button intent="none" icon={"link"} onClick={() => setShowPublicLinkManager(true)} text={"Gerar Link Público"} />
                                <Button disabled={getCarregandoListaDeMarcacoes} className="selector" style={{ background: "#ffffff", position: "relative", zIndex: 90000, color: "#13455e", border: "none", boxShadow: "none", borderRadius: "5px", outline: "none", width: "150px", display: "flex", alignItems: "center", justifyContent: "space-between", marginRight: "20px" }} text={getItemPickerCentroDeCusto?.descricao.substring(0, 10).concat("...") ?? "Empreendimento"} rightIcon="double-caret-vertical" />
                            </PickerCentroDeCusto>
                        </div>
                        <div style={{ display: "flex", background: "0", alignItems: "center", justifyContent: "center" }}>

                            <div style={{ width: "30px", height: "30px", borderRadius: "5px", marginRight: "1vw", cursor: "pointer", backgroundColor: "#ffffff", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={() => {
                                if (getFullscreen) {
                                    setFullscreen(!getFullscreen);
                                    setCollapse(true);
                                    handle.exit();
                                }
                                else {
                                    setFullscreen(!getFullscreen);
                                    setCollapse(false);
                                    handle.enter();
                                }
                            }}>
                                <Icon iconSize={20} icon="presentation" />
                            </div>

                            <div style={{ cursor: "pointer", display: getExibirMapa ? "flex" : "none", fontSize: "14px", width: "600px", height: "30px", background: "0", fontWeight: 500, transition: "width 1.5s", justifyContent: "center", marginTop: "0px" }}>
                                <div onClick={() => setVisaoMapa(0)} style={{ display: "flex", alignItems: "center", justifyContent: "space-around", padding: "0 10px", borderTopLeftRadius: "5px", borderRight: "1px solid #dbdbdb", borderBottomLeftRadius: "5px", width: window.matchMedia("(max-width: 650px)").matches == true ? "10%" : "25%", height: "100%", cursor: "pointer", visibility: "visible", opacity: "1", background: getVisaoMapa === 0 ? "#99acff" : "white", color: getVisaoMapa === 0 ? "#ffffff" : "#000000", transition: "background-color 1s, visibility 2s, opacity 5s, color 1s" }}>
                                    <Icon icon="path-search" />
                                    <span style={{ pointerEvents: "none", display: window.matchMedia("(max-width: 650px)").matches == true ? "none" : "initial" }}>Disponibilidade</span>
                                </div>
                                <div onClick={() => setVisaoMapa(1)} style={{ display: "flex", alignItems: "center", justifyContent: "space-around", padding: "0 10px", width: window.matchMedia("(max-width: 650px)").matches == true ? "10%" : "25%", height: "100%", cursor: "pointer", visibility: "visible", opacity: "1", background: getVisaoMapa === 1 ? "#99acff" : "white", color: getVisaoMapa === 1 ? "#ffffff" : "#000000", transition: "background-color 1s, visibility 2s, opacity 5s, color 1s" }}>
                                    <Icon icon="dollar" />
                                    <span style={{ pointerEvents: "none", display: window.matchMedia("(max-width: 650px)").matches == true ? "none" : "initial" }}>Inadimplência</span>
                                </div>
                                <div onClick={() => setVisaoMapa(2)} style={{ display: "flex", alignItems: "center", justifyContent: "space-around", padding: "0 10px", borderLeft: "1px solid #dbdbdb", width: window.matchMedia("(max-width: 650px)").matches == true ? "10%" : "25%", height: "100%", cursor: "pointer", visibility: "visible", opacity: "1", background: getVisaoMapa === 2 ? "#99acff" : "white", color: getVisaoMapa === 2 ? "#ffffff" : "#000000", transition: "background-color 1s, visibility 2s, opacity 5s, color 1s" }}>
                                    <Icon icon="double-caret-horizontal" />
                                    <span style={{ pointerEvents: "none", display: window.matchMedia("(max-width: 650px)").matches == true ? "none" : "initial" }}>Faixas Preço</span>
                                </div>
                                <div onClick={() => setVisaoMapa(3)} style={{ display: "flex", alignItems: "center", justifyContent: "space-around", padding: "0 10px", borderTopRightRadius: "5px", borderLeft: "1px solid #dbdbdb", borderBottomRightRadius: "5px", width: window.matchMedia("(max-width: 650px)").matches == true ? "10%" : "25%", height: "100%", cursor: "pointer", visibility: "visible", opacity: "1", background: getVisaoMapa === 3 ? "#99acff" : "white", color: getVisaoMapa === 3 ? "#ffffff" : "#000000", transition: "background-color 1s, visibility 2s, opacity 5s, color 1s" }}>
                                    <Icon icon="comparison" />
                                    <span style={{ pointerEvents: "none", display: window.matchMedia("(max-width: 650px)").matches == true ? "none" : "initial" }}>Categorias</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </Collapse>
                {/* Abridor Colapse */}
                <div style={{ width: "100%", height: "20px", backgroundColor: "#ffffff", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }} onClick={() => getCollapse === true ? setCollapse(false) : setCollapse(true)}>
                    <Lottie
                        options={{
                            loop: true,
                            autoplay: true,
                            animationData: LottieFiles.SwipeDown,
                            rendererSettings: {
                                preserveAspectRatio: "xMidYMid slice"
                            }
                        }}
                        height={30}
                        width={30}
                        style={getCollapse ? { transform: `rotate(180deg)`, transition: "transform 0.5s" } : { transform: `rotate(0deg)`, transition: "transform 0.5s" }}
                    />
                </div>
                {getExibirMapa == false && <div>
                    {getCarregandoListaDeUnidades != true && <div style={{ width: "100%", background: "0", display: "flex", flexDirection: "column" }}>
                        <Lottie
                            options={{
                                loop: true,
                                autoplay: true,
                                animationData: LottieFiles.LoadMaps,
                                rendererSettings: {
                                    preserveAspectRatio: "xMidYMid slice"
                                }
                            }}
                            height={500}
                            width={500}
                            style={{ marginTop: "122px" }}
                        />
                        <div className="loading" style={{ margin: "-100px auto 0 auto", fontWeight: "bold" }}>{(getCarregandoListaDeUnidades == undefined) ? "Por favor, selecione um empreendimento para exibir a tabela de disponibilidade" : ((getCarregandoListaDeUnidades == false) ? "Aguarde, estamos carregando seu empreendimento" : "Pronto, sua tabela de disponibilidade será exibida!")}</div>
                    </div>}
                </div>}
                {getExibirMapa == true &&
                    <div onClick={() => setCollapse(false)} style={{ height: "calc(100% - 20px)" }}>
                        {getCarregandoListaDeMarcacoes !== false && <div style={{ width: "100%", background: "0", display: "flex", flexDirection: "column" }}>
                            <Lottie
                                options={{
                                    loop: true,
                                    autoplay: true,
                                    animationData: LottieFiles.LoadMaps,
                                    rendererSettings: {
                                        preserveAspectRatio: "xMidYMid slice"
                                    }
                                }}
                                height={500}
                                width={500}
                                style={{ marginTop: "200px" }}
                            />
                            <div className="loading" style={{ margin: "-100px auto 0 auto", fontWeight: "bold" }}>{(getCarregandoListaDeMarcacoes == undefined) ? "Por favor, selecione um empreendimento para exibir o mapa" : ((getCarregandoListaDeMarcacoes == true) ? "Aguarde, estamos carregando seu empreendimento" : "Pronto, seu mapa logo será exibido!")}</div>
                        </div>}
                        {!getCarregandoListaDeMarcacoes && <Map getRefreshData={getRefreshData} RefreshData={RefreshData} RemoveRefreshData={RemoveRefreshData} visao={getVisaoMapa} refresh={getMapRefreshed} setRefresh={setMapRefreshed} polygonsData={getListaDeMarcacoes} setListaDeMarcacoes={setListaDeMarcacoes} tiposInadimplencia={getTiposInadimplencia} areas={getListaAreas} points={getListaPontosCentrais} />}
                    </div>}
            </FullScreen>
      
      {/* Gerenciador de Links Públicos */}
      <PublicLinkManager 
        isOpen={showPublicLinkManager} 
        onClose={() => setShowPublicLinkManager(false)} 
      />
        </Component.Container >
    );
    /* #endregion */
};

// const App: React.FC<viewModel> = (viewModel) => {
//     const queryClient = new QueryClient();

//     return (
//         <QueryClientProvider client = {queryClient}>
//             <View />
//         </QueryClientProvider>
//     );
// }

export default View;